<template>
  <vue-scroll :ops="ops">
    <v-card elevation="0">
      <v-toolbar elevation="0" color="transparent">
        <span class="headline font-weight-regular">Índice de Contenido</span>
        <v-spacer></v-spacer>
        <v-fab-transition>
          <v-btn
            fab
            x-small
            dark
            v-show="drawer"
            @click="openSidebar"
            color="error"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-fab-transition>
      </v-toolbar>

      <v-card-text class="pt-0">
        <v-treeview
          :items="items"
          :dense="true"
          :activatable="true"
          :hoverable="true"
          :open-on-click="true"
          :open-all="true"
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon>
              {{ open ? "mdi-folder-open-outline" : "mdi-circle-small" }}
            </v-icon>
          </template>
        </v-treeview>
      </v-card-text>
    </v-card>
  </vue-scroll>
</template>

<script>
//import { mapGetters } from "vuex";

export default {
  name: "HelpLayoutLeft",
  components: {},
  data() {
    return {
      ops: {
        bar: {
          background: "#cdcae0",
          keepShow: true,
          size: "12px",
          minSize: "0.1"
        }
      },
      items: [
        {
          id: 1,
          name: "Introducción"
        },
        {
          id: 2,
          name: "Fundamentos de Business Intelligence (BI)"
        },
        {
          id: 3,
          name: "Acerca de PacReport",
          children: [
            { id: 4, name: "Qué es PacReport" },
            { id: 5, name: "Funciones y Características" },
            { id: 6, name: "Para quiénes está recomendado su uso" },
            { id: 7, name: "Tipos de suscripciones" },
            { id: 8, name: "Requisitos del Sistema" },
            { id: 9, name: "Historial de cambios" }
          ]
        },
        {
          id: 10,
          name: "Espacio de información e índices"
        },
        {
          id: 11,
          name: "El Dashboard"
        },
        {
          id: 12,
          name: "Filtros y Consultas",
          children: [
            {
              id: 13,
              name: "Filtros",
              children: [
                { id: 14, name: "Qué es un filtro" },
                {
                  id: 15,
                  name: "Filtros disponibles",
                  children: [
                    { id: 16, name: "Descripción de la Compra" },
                    { id: 17, name: "Tipos de Procedimientos" },
                    { id: 18, name: "Régimen" },
                    { id: 19, name: "Cpcs" },
                    { id: 20, name: "Catálogo Electrónico" },
                    { id: 21, name: "Nombre Entidad" },
                    { id: 22, name: "Nombre Proveedor" },
                    { id: 23, name: "Provincia Entidad" },
                    { id: 24, name: "Cantón Entidad" }
                  ]
                },
                { id: 25, name: "Editar Filtro" },
                { id: 26, name: "Editar Filtro" },
                { id: 27, name: "Eliminar Filtro" }
              ]
            },
            {
              id: 28,
              name: "Consultas",
              children: [
                { id: 29, name: "Qué es una Consulta" },
                { id: 30, name: "Crear una Consulta" },
                { id: 31, name: "Editar Consulta" },
                { id: 32, name: "Eliminar Consulta" }
              ]
            }
          ]
        },
        {
          id: 33,
          name: "Exportar datos a Excell",
        },
        {
          id: 34,
          name: "Ejemplos y ejercicios prácticos"
        },
        {
          id: 35,
          name: "Preguntas Frecuentes"
        }
      ]
    };
  },
  props: {},
  methods: {
    openSidebar() {
      this.$store.dispatch("toggleDashBoardDrawer");
    }
  },
  computed: {
    drawer() {
      return this.$store.getters.dashboardDrawer;
    }
  },
  mounted() {},
  beforeDestroy() {}
};
</script>
<style>
/* This is for documentation purposes and will not be needed in your application */
</style>
